/**
 * A refused or failed backend call. The message keeps the one-line form
 * (`API Error (409): <raw text>`); `status` and the parsed `body` are what a
 * caller reads to act on a refusal (an overlay commit refused because my
 * changes were re-based says what changed and on which base).
 */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    /** the response parsed as JSON, else its raw text */
    public readonly body: unknown,
    text: string,
  ) {
    super(`API Error (${status}): ${text}`);
    this.name = 'ApiError';
  }

  /** The server's own account of the refusal: FastAPI's `detail` when the
   *  body has one, else the body itself. */
  get detail(): unknown {
    const b = this.body as { detail?: unknown } | null;
    return b && typeof b === 'object' && 'detail' in b ? b.detail : this.body;
  }
}
